/* cjl-pdp.js — PDP: dots cuadrados de la galería móvil (build PDP · medidas 01 móvil).
   Splide de Eurus va con pagination:false; aquí se pintan 8×8 sin radio y se sincronizan con
   .splide__slide.is-active. Click en un dot → click en el thumb nativo (oculto en móvil pero en DOM)
   para que sea Splide quien mueva. Sin motion propio; con reduced-motion no hay nada que apagar. */
(function () {
  'use strict';
  var instances = {};

  function init(root) {
    var id = root.id;
    if (!id || instances[id]) return;
    var list = root.querySelector('.splide__list');
    if (!list) return;
    var slides = list.querySelectorAll('.splide__slide');
    if (slides.length < 2) return;
    var thumbs = document.querySelectorAll('#' + id.replace('x-product-', 'x-product-thumbnail-') + ' .x-thumbnail button');
    var dots = document.createElement('div');
    dots.className = 'cjl-pdp__dots';
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cjl-pdp__dot';
      b.tabIndex = -1;
      b.addEventListener('click', function () { if (thumbs[i]) thumbs[i].click(); });
      dots.appendChild(b);
    });
    root.appendChild(dots);
    function sync() {
      slides.forEach(function (s, i) {
        dots.children[i].classList.toggle('is-active', s.classList.contains('is-active'));
      });
    }
    var mo = new MutationObserver(sync);
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    sync();
    instances[id] = { mo: mo, dots: dots };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('#MainContent .main-product .x-splide').forEach(init);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.x-splide').forEach(function (r) {
      var inst = instances[r.id];
      if (!inst) return;
      inst.mo.disconnect(); inst.dots.remove(); delete instances[r.id];
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
